import styled from 'styled-components';
import { ControlbarPopoverWrapper as ControlbarPopover } from '@containers/Home/components/Theme/ThemeDefault/styled';
import Modal from 'react-bootstrap/Modal';

export const ThemeWallWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #ffffff;
  .discoverMap {
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;

    /* .cards-address {
      position: absolute;
      left: 30%;
      top: 50%;
    } */
  }
  .--annotation {
    position: absolute;
    bottom: 30px;
    left: 54px;
    z-index: 1;
    &.hide {
      opacity: 0;
      pointer-events: none;
    }
    img {
      width: 240px;
      height: auto;
      pointer-events: none;
    }
    .close {
      position: absolute;
      top: -8px;
      right: -8px;
      background: #fff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;

      height: 20px;
      cursor: pointer;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.5);
    }
  }
  button {
    cursor: pointer;
  }
`;

export const HeaderWrapper = styled.div`
  z-index: 20;
  .cards-fly {
    position: absolute;
    top: 1rem;
    left: 1rem;
  }
  .search {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    top: 1rem;
    cursor: pointer;
    input {
      border-radius: 100px;
      // font-size: 14px;
      background: rgba(0, 0, 0, 0.7);
      color: #fff;
      width: 240px;
      border: none;
      padding: 0.5rem 2rem;
      pointer-events: none;
      transition: var(--transition-smooth);
      &::placeholder {
        color: #fff;
        opacity: 0.7;
      }
      &:focus,
      &:focus-visible {
        outline: none;
      }
    }
    .--icon-search {
      position: absolute;
      top: 50%;
      left: 12px;
      transform: translate(0, -50%);
      color: #fff;
    }
    .--icon-bar {
      position: absolute;
      color: #fff;
      top: 50%;
      transform: translate(0, -50%);
      right: 4px;
      border: 1px solid rgba(255, 255, 255, 0.25);
      background: rgba(0, 0, 0, 0.8);
      width: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 32px;
      border-radius: 50%;
    }
    &:hover {
      input {
        width: 320px;
      }
    }
    @media (max-width: 768px) {
      background: rgba(0, 0, 0, 0.5);
      right: 0;
      transform: none;
      left: initial;
      width: 36px;
      height: 42px;
      border-radius: 12px 0 0 12px;
      top: 12px;
      input {
        display: none;
      }
    }
  }
`;

export const ListSceneWrapper = styled.div`
  &.TourList {
    .--totalImg {
      cursor: pointer;
      position: absolute;
      bottom: 1rem;
      left: 1rem;
      .--item {
        width: 80px;
        height: 50px;
        overflow: hidden;
        border-radius: 2px;
        border: 1px solid #fff;
        transition: var(--transition-smooth);
        background: linear-gradient(
          0deg,
          rgba(0, 0, 0, 0.2) 0%,
          rgba(0, 0, 0, 0.2) 100%
        );
        &::after {
        }
        img {
          width: 100%;
          height: 100%;
        }
        &:nth-child(1) {
          position: relative;
          z-index: 3;
        }
        &:nth-child(2) {
          position: absolute;
          left: 4px;
          top: -4px;
          z-index: 2;
        }
        &:nth-child(3) {
          position: absolute;
          left: 8px;
          top: -8px;
          z-index: 1;
        }
      }
      .--number {
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        left: 50%;
        color: #fff;
        font-weight: 500;
        font-size: 18px;
        z-index: 3;
        width: max-content;
        text-shadow: 0 2px 4px #000;
      }
      &:hover {
        .--item {
          &:nth-child(2) {
            left: 8px;
            top: -8px;
          }
          &:nth-child(3) {
            left: 16px;
            top: -16px;
          }
        }
      }
    }
    .--tourLocation {
      position: absolute;
      left: 0;
      top: 0;
      transition: var(--transition-smooth);
      width: 200px;
      z-index: 21;
      background: rgba(0, 0, 0, 0.8);
      padding-top: 0;
      max-height: 100%;
      height: 100%;
      display: flex;
      flex-flow: column;
      align-items: flex-end;
      transform: translateX(-100%);

      &.active {
        transform: none;
        top: 0;

        opacity: 1;
      }
      .--hide {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        color: #fff;
        margin: 0.5rem;
        gap: 8px;
        cursor: pointer;
        width: max-content;
        background: rgba(0, 0, 0, 0.5);
        border: 1px solid rgba(255, 255, 255, 0.25);
        border-radius: 25px;
        padding: 4px 5px 4px 10px;
        font-size: 0.8rem;
        text-transform: uppercase;
        font-weight: 600;
        letter-spacing: 1px;
        i {
        }
      }
      .--listLocation {
        max-height: 100%;
        overflow-y: auto;
        height: max-content;
        display: flex;
        flex-flow: column;
        height: max-content;
        .--item {
          height: 100px;
          width: 100%;
          border-radius: 0;
          flex: 0 0 auto;
          .--imgLct {
            img {
              transition: var(--transition-smooth);
              height: 120%;
            }
            &:after {
              transition: var(--transition-regular);
            }
            &:hover {
              img {
                transform: scale(1.2);
              }
              &:after {
                opacity: 0;
              }
            }
          }
          .--totalImg {
            display: none;
          }
          .--titleLct {
            position: absolute;
            bottom: 0;
            padding: 0.8rem 0.8rem 0.4rem;
            left: 0;
            width: 100%;
            color: #fff;
            pointer-events: none;
            text-shadow: 0 1px 8px #000;
            .--nameLct {
              margin: 0;
            }
          }
        }
        &::-webkit-scrollbar {
          width: 5px;
        }
        &::-webkit-scrollbar-track {
          background: #000;
        }
        &::-webkit-scrollbar-thumb {
          background: var(--color-smoke);
          border-radius: 6px;
        }
      }
    }
  }
`;

export const ControlbarWrapper = styled.div`
  &.toolbar {
    position: absolute;
    left: 50%;
    bottom: 1rem;
    z-index: 20;
    transform: translate(-50%, 0);
    display: flex;
    border-radius: 100px;
    background: rgba(0, 0, 0, 0.5);
    gap: 2px;
    padding: 4px;
    backdrop-filter: blur(10px);
    .--item {
      width: 3rem;
      height: 3rem;
      font-size: 1.25rem;
      display: flex;
      border-radius: 50%;
      justify-content: center;
      align-items: center;
      color: #fff;
      position: relative;
      cursor: pointer;
      /* &:nth-child(3) {
        background: rgba(255, 255, 255, 0.2);
      } */
      &:hover {
        background: rgba(255, 255, 255, 0.1);
      }
      span {
        position: absolute;
        font-size: 12px;
        top: 3px;
        right: 3px;
        background: #fd4e5d;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    @media (max-width: 768px) {
      right: 0;
      left: initial;
      transform: none;
      flex-flow: column;
      border-radius: 12px 0 0 12px;
      backdrop-filter: initial;
      top: 175px;
      bottom: initial;
      width: 36px;
      .--item {
        width: 100%;
        height: 36px;
      }
    }
  }
`;

export const ControlbarPopoverWrapper = styled(ControlbarPopover)``;

export const PostSceneWrapper = styled.div`
  z-index: 20;
  &.cards-info {
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 30%;
    max-width: 360px;
    border-radius: 8px;
    overflow: hidden;
    z-index: 21;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    transition: all 0.5s ease;
    &.active {
      transform: translate(376px, 0);
    }
    .--close {
      cursor: pointer;
    }
    .cards-header {
      padding: 0.8rem 1rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .--title-cards {
        display: flex;
        align-items: center;
        gap: 8px;
        .--icon {
          img {
            width: 16px;
          }
        }
        h6 {
          color: #fff;
          font-size: 0.9rem;
        }
      }
    }
    .cards-body {
      padding: 0 1rem 1rem;
      max-height: calc(100vh - 340px);
      position: relative;
    }
    .infoAddress {
      transition: all 0.5s ease;
      display: flex;
      flex-flow: column;
      max-height: calc(100vh - 360px);
    }
    .--bot {
      width: 100%;
      transition: all 0.5s ease;
      display: flex;
      flex-flow: column;
      height: 100%;
      max-height: calc(100vh - 300px);
      overflow: hidden;
      @media (max-width: 640px) {
        max-height: calc(80vh - 50px);
      }
    }
    .--comment {
      overflow: hidden;
      flex: 1;
      display: flex;
      flex-flow: column;
      .--overview {
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
        padding-bottom: 0.8rem;
        display: flex;
        align-items: center;
        gap: 12px;
        .--back {
          width: 2rem;
          height: 2rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.13s ease-out;
          border-radius: 50%;
          &:hover {
            background-color: rgba(255, 255, 255, 0.2);
          }
        }
        .--title {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .--name {
          font-size: 1.2rem;
          font-weight: 600;
        }
        .--total {
          border-radius: 6px;
          padding: 2px 6px 0px;
          display: flex;
          align-items: center;
          font-size: 0.9rem;
          background: rgba(255, 255, 255, 0.3);
        }
      }
      .--empty {
        min-height: 120px;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        gap: 1rem;
        span {
          opacity: 0.5;
        }
      }
      .--addCmt {
        background: var(--color-1);
        padding: 8px 14px 6px;
        cursor: pointer;
        border-radius: 6px;
        width: max-content;
        display: flex;
        gap: 8px;
        align-items: center;
        font-weight: 500;
      }
      .--listCmt {
        display: flex;
        flex-flow: column;
        gap: 24px;
        overflow-y: auto;
        width: calc(100% + 0.8rem);
        padding: 1rem 1rem 1rem 0;
        flex: 1;
        &::-webkit-scrollbar {
          width: 4px;
        }
        &::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.2);
        }
        &::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.5);
        }
      }
    }
    .commentUser {
      .--children {
        padding-left: 44px;
        display: flex;
        flex-flow: column;
        margin-top: 6px;
        gap: 6px;
      }
    }
    .--commentuser {
      padding: 8px;
      background: #fff;
      border-radius: 6px;
      flex: 1;
      width: calc(100% - 43px);
      .--listimg {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 8px;
        margin-top: 4px;
        .--delete {
          position: absolute;
          width: 20px;
          height: 20px;
          border: 2px solid #fff;
          background: #e3e3e3;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          top: -10px;
          right: -10px;
          font-size: 12px;
          cursor: pointer;
        }
        .--img {
          width: 100%;
          height: 60px;
          position: relative;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 6px;
          }
        }
      }
      .--btn {
        margin-top: 8px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
      }
      .--btnSentComment {
        cursor: pointer;
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background: var(--color-1);
        transition: var(--transition-smooth);
        &:hover {
          transform: scale(1.1);
        }
      }
      .--btnAddImg {
        cursor: pointer;
        button {
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--color-smoke);
          gap: 8px;
          font-weight: 500;
          padding: 0;
          background: transparent !important;
          // &:hover {
          //   background: #eee;
          // }
        }
      }
    }
    .--writeComment {
      padding: 1rem 0;
      border-top: 1px solid rgba(255, 255, 255, 0.3);
      height: max-content;
      .--avatar {
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 50%;
        overflow: hidden;
        flex: 0 0 auto;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .--write {
        display: flex;
        gap: 8px;
        width: 100%;
      }

      .--input {
        background: transparent;
        height: max-content;
        color: rgb(0, 0, 0);
        outline: none;
        border: none;
        max-width: 100%;
        &:focus,
        &:focus-visible {
          border: none !important;
        }
      }
    }
    .itemLocation {
      .--imgLct {
        &:after {
          height: 60%;
          background: linear-gradient(0deg, black, transparent);
          opacity: 1;
        }
      }
    }
    @media (max-width: 640px) {
      left: 0;
      right: initial;
      transform: translate(0, 0);
      width: 100%;
      max-width: none;
      border-radius: 20px 20px 0 0;
      bottom: 0;
      top: initial;
      background: var(--color-dark);
      &.active {
        transform: translate(0, 100%);
      }
      .cards-body {
        max-height: 80vh;
      }
      .infoAddress {
        max-height: calc(100vh - 280px);
      }
    }
  }
`;

export const DialogSearchLocationWrapper = styled(Modal)`
  &.modal-filter {
    .modal-dialog {
      max-width: 80vw;
    }
    .modal-content {
      padding: 1.5rem;
      border-radius: 20px;
    }
    .cards-header {
      display: flex;
      gap: 12px;
      padding-bottom: 0.8rem;
      // border-bottom: 1px solid #e8e8e8;
      // margin-bottom: 20px;
      align-items: center;
    }
    .--title {
      margin-bottom: 0;
      font-size: 18px;
      font-weight: 500;
    }
    .--search {
      position: relative;
      margin-bottom: 0.5rem;
      input {
        border-radius: 10px;
        background: #fff;
        border: 2px solid #ddd;
        width: 100%;
        height: 40px;
        padding: 0 1rem 0 2rem;
        transition: var(--transition-regular);
        &::placeholder {
          font-size: 14px;
        }
        &:focus,
        &:focus-visible {
          border: 2px solid var(--color-1) !important;
          outline: none;
        }
      }
      i {
        position: absolute;
        top: 50%;
        left: 12px;
        transform: translate(0, -50%);
      }
    }
    .--cate {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    .--filter {
      .--name {
        // font-size: 14px;
        // margin-bottom: 8px;
        display: none;
      }
    }
    .--tab {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;
      .--item {
        padding: 8px 12px;
        display: flex;
        gap: 10px;
        cursor: pointer;
        border-radius: 100px;
        border: 1px solid #e8e8e8;
        font-size: 14px;
        align-items: center;
        transition: all 0.13s ease;
        line-height: 1;
        &.active {
          border: 1px solid var(--color-1) !important;
          color: #fff !important;
          background: var(--color-1) !important;
          img {
            filter: brightness(100) invert(0);
          }
        }
        &:hover {
          background: rgba(0, 0, 0, 0.05);
        }
        img {
          width: 12px;
        }
      }
    }
    .--cate {
    }
    .--listLocation {
      margin-top: 1.5rem;
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
      height: auto;
      max-height: calc(100vh - 220px);
      overflow: auto;
      .--item {
        width: calc(100% / 5 - 10px);
        height: 140px;
        .--imgLct {
          img {
          }
          &:after {
            height: 60%;
            background: linear-gradient(0, black, transparent);
            opacity: 1;
          }
        }
        .--titleLct {
          .--nameLct {
            margin: 0;
          }
        }
      }
    }
    @media (max-width: 640px) {
      .modal-dialog {
        max-width: 100%;
      }
      .--tab {
        flex-wrap: unset;
        overflow-x: auto;
        .--item {
          flex: 0 0 auto;
        }
      }
      .--listLocation {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        max-height: calc(100vh - 350px);
        .--item {
          width: 100%;
        }
      }
    }
  }
`;

export const MapWrapper = styled.div`
  position: absolute;
  right: 1rem;
  z-index: 22;
  bottom: 3.5rem;
  transition: var(--transition-smooth);
  width: 150px;
  height: 90px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.5);
  .--img {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .--view {
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translate(-50%, 0);
    padding: 4px 12px;
    font-size: 12px;
    line-height: 1;
    color: #fff;
    width: max-content;
    background: var(--color-1);
    border-radius: 100px;
    span {
      cursor: pointer;
    }
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

export const GoogleMapWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const MarkerWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  cursor: pointer;
  img {
    width: 40px;
  }
`;
